const ARRAY_DATA_KEYS = ["flights", "scheduleFlights", "allFlights", "flightOperations"];

export const getDataRecordId = (record) => {
    if (!record || typeof record !== "object") return null;

    return record.id ?? record.flight_id ?? record.schedule_flight_id ?? record.operation_flight_id ?? null;
};

const toIdKey = (value) => {
    if (value === null || value === undefined) return null;
    return String(value);
};

export const getDataRecords = (data) => {
    if (Array.isArray(data)) return data;
    if (!data || typeof data !== "object") return [];

    for (const key of ARRAY_DATA_KEYS) {
        if (Array.isArray(data[key])) return data[key];
    }

    return [];
};

export const getDataRecordIds = (data) => {
    return getDataRecords(data)
        .map(getDataRecordId)
        .filter((id) => id !== null && id !== undefined);
};

export const getDataRecordCount = (data) => {
    return getDataRecords(data).length;
};

const getSelectedIds = (instance) => {
    const filterState = instance?.filterState || instance?.filter_state;
    if (!filterState) return null;

    if (Object.prototype.hasOwnProperty.call(filterState, "selectedIds")) {
        return filterState.selectedIds;
    }

    if (Object.prototype.hasOwnProperty.call(filterState, "selected_ids")) {
        return filterState.selected_ids;
    }

    return null;
};

const filterRecords = (records, selectedKeySet) => {
    return records.filter((record) => {
        const recordKey = toIdKey(getDataRecordId(record));
        return recordKey !== null && selectedKeySet.has(recordKey);
    });
};

export const getEffectiveData = (instance, rawData) => {
    const selectedIds = getSelectedIds(instance);
    if (selectedIds === null || selectedIds === undefined) return rawData;
    if (!Array.isArray(selectedIds)) return rawData;

    const selectedKeySet = new Set(selectedIds.map(toIdKey).filter((id) => id !== null));

    if (Array.isArray(rawData)) {
        return filterRecords(rawData, selectedKeySet);
    }

    if (!rawData || typeof rawData !== "object") {
        return rawData;
    }

    const nextData = { ...rawData };
    let hasFilteredArray = false;

    ARRAY_DATA_KEYS.forEach((key) => {
        if (Array.isArray(rawData[key])) {
            nextData[key] = filterRecords(rawData[key], selectedKeySet);
            hasFilteredArray = true;
        }
    });

    return hasFilteredArray ? nextData : rawData;
};
